import { Text } from '@pairy/pds-react';
import React, { forwardRef } from 'react';

import { GOOGLE_EVENT_ID } from '../../../../../constant/googleEventId';

import * as Styled from './index.styles';

interface Props {
  text: string;
  boxColor: string;
  textColor: string;
  buttonText: string;
  top: string;
  left: string;
  handleButtonClick: (e: React.MouseEvent) => void;
  size?: 'sm' | 'default';
  /** 페이지 폭에 맞춰 좁힌 최대 너비(px). 미지정 시 크기별 기본값 */
  maxWidth?: number;
  /** 실측 전 한 프레임 동안 숨겨 위치가 튀는 것을 막는다 */
  isHidden?: boolean;
}

// pdf viewer와 message box 설정창에서 공통으로 사용될 message box

const MessageBox = forwardRef<HTMLElement, Props>(
  (
    {
      text,
      boxColor,
      textColor,
      buttonText,
      top,
      left,
      handleButtonClick,
      size = 'default',
      maxWidth,
      isHidden = false,
    },
    ref,
  ) => {
    return (
      <Styled.Container
        ref={ref}
        gap={size === 'default' ? 16 : 12}
        direction="column"
        padding={size === 'default' ? 32 : 20}
        style={{
          backgroundColor: `${boxColor}`,
          top: `${top}`,
          left: `${left}`,
          maxWidth: `${maxWidth ?? (size === 'default' ? 360 : 280)}px`,
          visibility: isHidden ? 'hidden' : undefined,
        }}
        /* 박스 여백 탭이 뷰어 셸의 컨트롤 토글로 전파되지 않게 한다 */
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Text
          variant={size === 'default' ? 'lg-medium' : 'md-medium'}
          textAlign="center"
          style={{ color: `${textColor}` }}
        >
          <Styled.MessageText>{text}</Styled.MessageText>
        </Text>
        <Styled.MessageBoxButton
          id={GOOGLE_EVENT_ID.messageBoxButton}
          style={{ backgroundColor: `${textColor}` }}
          width="100%"
          paddingX={16}
          paddingY={12}
          radius={9999}
          onClick={handleButtonClick}
        >
          <Text
            id={GOOGLE_EVENT_ID.messageBoxButton}
            variant="md-medium"
            textAlign="center"
            style={{ color: `${boxColor}` }}
          >
            {buttonText}
          </Text>
        </Styled.MessageBoxButton>
      </Styled.Container>
    );
  },
);

MessageBox.displayName = 'MessageBox';

export default MessageBox;
